import React from "react";
import TableUtility from "../../../Common/UtilityCommon/TableUtility";

const CompanyEnteriesUtility = () => {
   const apiUrl = `${process.env.REACT_APP_API}/getall-CompanyEntries`;
   const columns = [
      { label: "ID", key: "Id" },
      { label: "Date", key: "Date" },
      { label: "Amount", key: "Amount" },
      { label: "Company Name", key: "Company_Name_E" },
      { label: "To Ac Name", key: "TOACCNAME" },
      { label: "From Ac Name", key: "FromACCNAME" },
      { label: "Cross Company Name", key: "CrossCompanyname" },
      { label: "Cross To Ac Name", key: "CrossToACCNAME" },
      { label: "Cross From Ac Name", key: "CrossFromACCName" },
   ];
   return (
      <TableUtility
         title="Multiple Company Entries"
         apiUrl={apiUrl}
         columns={columns}
         rowKey="Id"
         addUrl="/companyentries-api"
         detailUrl="/companyentries-api"
         permissionUrl="/company-entry-utility"
      // includeYearCode = {includeYearCode}

      />
   );

};

export default CompanyEnteriesUtility;